import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const PendingApproval = () => {
  const navigate = useNavigate();
  const { signOut, profile } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <>
      <Helmet>
        <title>Pending Approval - DiagnosticAI</title>
      </Helmet>
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <div className="clinical-card p-8 max-w-2xl w-full text-center">
          <div className="w-24 h-24 bg-warning/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="Clock" size={48} color="var(--color-warning)" />
          </div>

          <h1 className="text-3xl font-bold text-foreground mb-4">Application Under Review</h1>

          <p className="text-lg text-muted-foreground mb-8">
            Thank you for completing your profile, <span className="font-semibold text-foreground">{profile?.full_name}</span>.
          </p>

          <div className="bg-muted/50 rounded-lg p-6 mb-8 text-left">
            <h2 className="text-xl font-semibold text-foreground mb-4">What happens next?</h2>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Icon name="CheckCircle" size={20} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                <span className="text-muted-foreground">
                  Our admin team is reviewing your medical credentials and uploaded documents
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Icon name="CheckCircle" size={20} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                <span className="text-muted-foreground">
                  You will receive an email notification once your application is approved
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Icon name="CheckCircle" size={20} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                <span className="text-muted-foreground">
                  This process typically takes 1-2 business days
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-8">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
              <div className="text-left">
                <p className="text-sm font-medium text-primary mb-1">Application Status</p>
                <p className="text-xs text-muted-foreground">
                  Status: <span className="font-semibold text-warning">Pending Admin Approval</span>
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  Submitted: {new Date(profile?.created_at)?.toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <Button variant="outline" fullWidth onClick={handleSignOut} iconName="LogOut" iconPosition="right">
              Sign Out
            </Button>

            <p className="text-xs text-muted-foreground">
              Need help? Contact our support team at{' '}
              <a href="mailto:support@diagnosticai.com" className="text-primary hover:underline">care@mydocrefer.org

              </a>
            </p>
          </div>
        </div>
      </div>
    </>);

};

export default PendingApproval;